"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.INTERNAL_PROPS_MARK = void 0;
var INTERNAL_PROPS_MARK = 'RC_SELECT_INTERNAL_PROPS_MARK';
exports.INTERNAL_PROPS_MARK = INTERNAL_PROPS_MARK;


//////////////////
// WEBPACK FOOTER
// ./~/rc-select/lib/interface/generator.js
// module id = 441
// module chunks = 0